import styled from 'styled-components';
import WithDirection from "../../../../config/withDirection";

const StyleWrapper = styled.div`
    position: relative;
    height: 90px;
    padding: 21px 22px 21px 26px;
    background-color: rgba(255, 255, 255, 1);
    color: rgba(12, 183, 148, 1);
    text-align: left;
    letter-spacing: 0.08em;

    .header-text { line-height: 26px; font-family: 'Montserrat'; font-size: 22px; text-transform: uppercase; }
    .header-explain { line-height: 19px; font-family: 'Montserrat'; font-size: 16px; font-weight: 300; }
    .header-icon {
        position: absolute;
        top: 22px; right: 22px;
        width: 32px;
        height: 32px;
    }
    .header-icon img { width: 100%; }

    @media screen and (max-width: 767px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 9px;

        .header-icon { top: 50%; transform: translateY(-50%); }
    }
`;
export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/GridHeader/Wrapper.js